module.exports = __webpack_public_path__ + "static/media/Indonesia.eb140c98.png";